module.exports = __webpack_public_path__ + "static/media/retour.4809566e.svg";